import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { connect } from "react-redux"
import { Button } from "antd"
import { isStateLoading } from "../filters/selectors"
import type { AgendaTypes } from "../../utils/types/pagesTypes"
import { downloadReport } from "../screens/reports/actions"

type Props = {
    dataLoading: boolean
    haveData?: boolean
    identifier: AgendaTypes
    exportType: Maybe<"csv" | "excel">
    downloadReport: (reportAgenda: AgendaTypes, exportType: Maybe<"csv" | "excel">) => void
}

class DownloadReportButton extends React.PureComponent<Props> {
    static defaultProps = {
        haveData: true,
        exportType: null,
    }

    render() {
        return (
            <Button
                icon="download"
                disabled={this.props.dataLoading || !this.props.haveData}
                onClick={() => {
                    this.props.downloadReport(this.props.identifier, this.props.exportType)
                }}
            />
        )
    }
}

const mapStateToProps = (state, props) => ({
    dataLoading: isStateLoading(state, props.identifier),
})

const mapDispatchToProps = {
    downloadReport: downloadReport,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(DownloadReportButton)
